// France
export const locale = {
  GENERAL: {
    BACK_TO_TOP: 'Retour en haut',
    IMPORTANT: 'Important',
    SELECT: 'Sélectionner',
    PREVIOUS: 'Précédent',
    NEXT: 'Suivant',
    DELETE: 'Supprimer',
    OK: 'Ok',
    ATTENTION: 'Attention !',
    FAQ: 'FAQ',
    BACK_HOME: 'RETOURNER À L’ACCUEIL',
    REPLAY: 'REJOUER',
    ACCEPT_ALL: 'Tout accepter',
    CLOSE: 'Fermer',
    LEARN_MORE: 'En savoir plus',
    MESSAGE_SEND: 'Message envoyé avec succès',
    SEND: 'Envoyer',
    SEND_US_EMAIL: 'Envoyez-nous un e-mail',
    SIZE: 'Taille',
  },
  STORE: {
    SEARCH_TITLE:
      'Commencez à taper pour voir les produits que vous recherchez.',
    WELCOME: 'Bienvenue chez TUMAR',
    GEOLOCATION:
      'Nous utilisons la géolocalisation pour afficher les <br> bons produits, prix et calculs d’expédition',
    ENABLE_LOCATION:
      'Veuillez activer la détection de localisation pour continuer',
    GO_STORE: 'Aller à la boutique',
    IMPORTANT_GEOLOCATION_WARNING:
      'Il est très important pour nous de connaître votre géolocalisation afin de vous fournir les bons produits et prix. Êtes-vous sûr de vouloir continuer sans géolocalisation ?',
    NO_CONTENT: 'Il n’y a pas de contenu sur cette page',
    WORKSHOPS: 'ATELIERS',
    ADD_TO_CART: 'AJOUTER AU PANIER',
    SALE: 'Promotion',
  },
  NOT_FOUND: {
    PAGE_NOT_FOUND: 'Oups, cette page est introuvable',
    LINK: 'Le lien peut ne pas être disponible pour vous',
    REMOVED: 'ou la page a peut-être été supprimée.',
  },
  REVIEW: {
    LEAVE_REVIEW: 'Laisser un avis',
    HOW_RATE: 'Comment évalueriez-vous ?',
    REVIEW_TEXT: 'Texte de l’avis',
    RATE_US: 'Évaluez-nous',
    SUBMIT_REVIEW: 'Soumettre l’avis',
    REVIEW_VERIFIED:
      'Tous les avis sur Cool Co. Reviews sont vérifiés sous 48 heures avant publication pour garantir leur authenticité et leur exactitude.',
    OUR_REVIEWS: 'NOS AVIS',
    YOUR_OPINION:
      'Votre avis est important pour nous ! Si vous souhaitez partager vos impressions sur nos produits ou laisser un avis, nous serions ravis de vous entendre. Cela nous aidera à nous améliorer et à encore mieux vous satisfaire. Merci de nous avoir choisis !',
    WRITE_REVIEW: 'Rédiger un avis',
    REPLAY_TO_REVIEW: 'Répondre à l’avis',
  },
  BASKET: {
    SPEACIAL_ITEM:
      'Vous avez un article spécial dans votre panier. Vous devez finaliser cet achat pour acheter d’autres articles.',
  },
  COOKIE: {
    TITLE: 'Consentement à l’utilisation des cookies',
    ACCEPT:
      'En cliquant sur « Accepter tous les cookies », vous acceptez que Stack Exchange puisse stocker des cookies sur votre appareil et divulguer des informations conformément à notre',
    POLICY: 'Politique relative aux cookies',
  },
  CHAT_BOT: {
    TITLE: 'Tumar Chat Bot',
    SUBTITLE: 'Réponses aux questions',
  },
  TRANSLATOR: {
    SELECT: 'Sélectionnez votre langue',
  },
  MENU: {
    NEW: 'Nouveau',
    ACTIONS: 'Actes',
    CREATE_POST: 'Créer un nouveau Post',
    PAGES: 'Pages',
    FEATURES: 'Fonctionnalités',
    APPS: 'Applications',
    DASHBOARD: 'Tableau de Bord',
  },
  AUTH: {
    GENERAL: {
      OR: 'Ou',
      SUBMIT_BUTTON: 'Soumettre',
      NO_ACCOUNT: 'Ne pas avoir de compte?',
      SIGNUP_BUTTON: 'Registre',
      FORGOT_BUTTON: 'Mot de passe oublié',
      BACK_BUTTON: 'Back',
      PRIVACY: 'Privacy',
      LEGAL: 'Legal',
      CONTACT: 'Contact',
    },
    LOGIN: {
      TITLE: 'Créer un compte',
      BUTTON: 'Sign In',
    },
    FORGOT: {
      TITLE: 'Forgot Password?',
      DESC: 'Enter your email to reset your password',
      SUCCESS: 'Your account has been successfully reset.',
    },
    REGISTER: {
      TITLE: 'Sign Up',
      DESC: 'Enter your details to create your account',
      SUCCESS: 'Your account has been successfuly registered.',
    },
    INPUT: {
      EMAIL: 'Email',
      FULLNAME: 'Fullname',
      PASSWORD: 'Mot de passe',
      CONFIRM_PASSWORD: 'Confirm Password',
      USERNAME: "Nom d'utilisateur",
    },
    VALIDATION: {
      INVALID: "{{name}} n'est pas valide",
      REQUIRED: '{{name}} est requis',
      MIN_LENGTH: '{{name}} minimum length is {{min}}',
      AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
      NOT_FOUND: 'The requested {{name}} is not found',
      INVALID_LOGIN: 'The login detail is incorrect',
      REQUIRED_FIELD: 'Required field',
      MIN_LENGTH_FIELD: 'Minimum field length:',
      MAX_LENGTH_FIELD: 'Maximum field length:',
      INVALID_FIELD: 'Field is not valid',
    },
  },
  ECOMMERCE: {
    COMMON: {
      SELECTED_RECORDS_COUNT: "Nombre d'enregistrements sélectionnés: ",
      ALL: 'All',
      SUSPENDED: 'Suspended',
      ACTIVE: 'Active',
      FILTER: 'Filter',
      BY_STATUS: 'by Status',
      BY_TYPE: 'by Type',
      BUSINESS: 'Business',
      INDIVIDUAL: 'Individual',
      SEARCH: 'Search',
      IN_ALL_FIELDS: 'in all fields',
    },
    ECOMMERCE: 'éCommerce',
    CUSTOMERS: {
      CUSTOMERS: 'Les clients',
      CUSTOMERS_LIST: 'Liste des clients',
      NEW_CUSTOMER: 'Nouveau client',
      DELETE_CUSTOMER_SIMPLE: {
        TITLE: 'Suppression du client',
        DESCRIPTION: 'Êtes-vous sûr de supprimer définitivement ce client?',
        WAIT_DESCRIPTION: 'Le client est en train de supprimer ...',
        MESSAGE: 'Le client a été supprimé',
      },
      DELETE_CUSTOMER_MULTY: {
        TITLE: 'Supprimer les clients',
        DESCRIPTION:
          'Êtes-vous sûr de supprimer définitivement les clients sélectionnés?',
        WAIT_DESCRIPTION: 'Les clients suppriment ...',
        MESSAGE: 'Les clients sélectionnés ont été supprimés',
      },
      UPDATE_STATUS: {
        TITLE: 'Le statut a été mis à jour pour les clients sélectionnés',
        MESSAGE:
          'Le statut des clients sélectionnés a été mis à jour avec succès',
      },
      EDIT: {
        UPDATE_MESSAGE: 'Le client a été mis à jour',
        ADD_MESSAGE: 'Le client a été créé',
      },
    },
  },
}
